import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import ajax from '@/utils/ajax';

import { NonBillableReason } from '../types/non_billable_reason';

export const nonBillableReasonRepository = {
  async list(host: string): Promise<NonBillableReason[]> {
    const path = `${host}/api/dugout/non_billable_reasons/?active=true`;
    const response = await ajax.get({ url: path });
    return response.data;
  }
};

const NonBillableReasonRepository = (): {
  list: () => Promise<NonBillableReason[]>;
} => {
  const { host } = useContext(AppContext);
  return {
    async list(): Promise<NonBillableReason[]> {
      return nonBillableReasonRepository.list(host);
    }
  };
};

export default NonBillableReasonRepository;
